export const isSmallScreenLaptopMixin = {
  data () {
    return {}
  },
  watch: {},
  computed: {
    isSmallScreen () {
      return this.$vuetify.breakpoint.name === 'md' || this.$vuetify.breakpoint.width <= 1440
    },
  },
  methods: {}
}
